var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { addressUnavailable, noAddressMeta, address, city, state_code, postal_code,
full_address_display } = options; 
__p+='\n\n';
 if (addressUnavailable && noAddressMeta) {

__p+=' Address Not Available ';
 } else if (address) { 
__p+=' '+
((__t=(
address ))==null?'':__t)+
',\n<span>\n  '+
((__t=( city ))==null?'':__t)+
', '+
((__t=( state_code ))==null?'':__t)+
' '+
((__t=( postal_code ))==null?'':__t)+
'\n</span>\n';
 } else { 
__p+=' '+
((__t=( full_address_display ))==null?'':__t)+
' ';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-subsec-property-header-address-ab-v3.jst.ejs